import React from "react";

import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import { Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import Badge from "@mui/material/Badge";
import AvatarGroup from "@mui/material/AvatarGroup";
import StorefrontIcon from "@mui/icons-material/Storefront";
import {
  query,
  collection as firebaseCollection,
  where,
  getCountFromServer,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useSelector } from "react-redux";

const EntityDonationMessage = ({
  item,
  entityDonation,
  setChatId,
  setParticularChatDonation,
  setChatDrawerState,
  t,
}) => {
  const [unreadMessageCount, setUnreadMessageCount] = React.useState(0);
  const handleChat = React.useCallback(() => {
    setChatDrawerState(true);
    setChatId(item.chatUid);
    setParticularChatDonation(item);
  }, [item]);
  const {
    auth: { profile },
  } = useSelector((state) => state);

  React.useEffect(() => {
    const getData = async () => {
      const q = query(
        firebaseCollection(db, "chats", item.chatUid, "messages"),
        where("isRead", "==", false),
        where("senderId", "!=", profile?.userId)
      );
      const snapshot = await getCountFromServer(q);
      setUnreadMessageCount(snapshot.data().count);
    };
    item.chatUid && getData();
  }, [item]);
  
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1,
        m: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
      key={item.chatUid}
    >
      <Stack direction={"column"}>
        <Typography variant="body1" fontFamily={"Poppins"} sx={{ mb: 1 }}>
          {new Date(item.donationCreatedDate).getFullYear()}
          {item.donation_id} (
          {new Date(item.collectionCreatedDate).getFullYear()}
          {item.collectionId})
        </Typography>
        <Stack direction="row">
          <Stack direction="column" spacing={1}>
            <Stack direction="row">
              <CalendarMonthOutlinedIcon />
              <Typography
                variant="body2"
                sx={{ ml: 2 }}
                textTransform={"capitalize"}
              >
                {t("in")}{" "}
                <span>
                  {new Date(item.availableFromDate).toLocaleString("pt-PT", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    formatMatcher: "best fit",
                  })}
                </span>{" "}
                {t("until")}{" "}
                <span>
                  {new Date(item.expiryDate).toLocaleString("pt-PT", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    formatMatcher: "best fit",
                  })}
                </span>
              </Typography>
            </Stack>
            <Stack direction="row">
              <StorefrontIcon />
              <Typography
                variant="body2"
                sx={{ ml: 2 }}
                textTransform={"capitalize"}
              >
                {item.collectionEntityDetail.entity.isParentEntity &&
                !item.collectionEntityDetail.entity.isGroupEntity
                  ? item.collectionEntityDetail.entity.entityName
                  : item.collectionEntityDetail.entity.entityName}{" "}
              </Typography>
            </Stack>
            <Stack direction="row">
              {item?.donationProducts !== undefined &&
                item.donationProducts.length > 0 && (
                  <AvatarGroup
                    max={4}
                    sx={{
                      justifyContent: "space-between",
                      "& .MuiAvatarGroup-avatar": {
                        marginLeft: "0px !important",
                        width: "24px",
                        height: "24px",
                        fontSize: "14px",
                        backgroundColor: "#E4F2E8",
                        color: "#1B727E",
                      },
                    }}
                    variant="rounded"
                  >
                    {item?.donationProducts.map((pro) => (
                      <Avatar
                        alt={pro.productGroup}
                        src={`/static/products/${pro.productId}.jpg`}
                        variant="rounded"
                        sx={{
                          ml: "0px !important",
                          width: "24px",
                          height: "24px",
                          "& .MuiAvatar-root-MuiAvatarGroup-avatar": {
                            marginLeft: "0px !important",
                          },
                        }}
                        key={pro.productId}
                      />
                    ))}
                  </AvatarGroup>
                )}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <IconButton aria-label="chat-button" sx={{ mx: 3 }} onClick={handleChat}>
        <Badge color="primary" badgeContent={unreadMessageCount} max={99}>
          <ChatOutlinedIcon />
        </Badge>
      </IconButton>
    </Paper>
  );
};

export default EntityDonationMessage;
